import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { rootActions } from "../../actions/rootActions";
import { thanhPhanMonApi } from "../../../api/category/thanhPhanMonApi";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { eThanhphanMonActionIds, IThanhPhanMonActionTypes } from "../../action-types/category/IThanhPhanMonActions";
import { IThanhPhanMon } from "../../../model/response/category/IThanhPhanMon";

const mainAction = rootActions.category.thanhPhanMon;
export function* thanhPhanMonSaga(): any {
    yield takeLatest(eThanhphanMonActionIds.LOAD_START, loadWorker);
    yield takeEvery(eThanhphanMonActionIds.SAVE_START, saveWorker);
     yield takeEvery(eThanhphanMonActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
    const res: IBaseResponse = yield call(thanhPhanMonApi.SelectAll);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"));
    }
}

function* saveWorker(action: IThanhPhanMonActionTypes): any {
   let res: IBaseResponse;
   const payload = action.payload as IThanhPhanMon;
   if (payload.id_thanh_phan > 0) {
       res = yield call(thanhPhanMonApi.Update, payload.id_thanh_phan, payload);      
   } else {
         res = yield call(thanhPhanMonApi.Insert, payload);
    }
    if (res.is_success) {
     yield put(mainAction.SAVE_SUCCESS(toLowerCaseDeep(res.data)));
    }
    else {
     yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"));
    }
}

function* deleteWorker(action: IThanhPhanMonActionTypes): any {
    const id= action.payload as number;
    const res: IBaseResponse = yield call(thanhPhanMonApi.Delete, id);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"));
    }
}

